module.exports = __webpack_public_path__ + "static/img/home_fn_content_06.7dcc490.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_06.png
// module id = a2Fv
// module chunks = 34